import useLanguage from '@op/hooks/useLanguage';
import { formatDateToServerDataFunc } from '@op/utils/time';
import React from 'react';
import './index.scss';
import SvgIcon from '@home/components/SvgIcon';
import { IRealtimeCommonTitle } from '../../../type';

export default function CommonTitle({
  title,
  endTime,
  hasTitleArrow,
  handleTitleOnClick,
  children,
  className,
}: IRealtimeCommonTitle) {
  const { formatMessage } = useLanguage();

  return (
    <div
      className={`${className} ${
        hasTitleArrow ? 'card-slot-title-hover' : 'card-slot-title'
      }`}
      onClick={() => {
        handleTitleOnClick?.();
      }}
    >
      <span className="dbo-realtime-opinions-card-title">
        {formatMessage({ id: title })}
      </span>
      {children}
      {hasTitleArrow && (
        <SvgIcon type="arrow-right" className="card-slot-icon" />
      )}
      {endTime && (
        <span className="dbo-realtime-opinions-card-time">
          {formatDateToServerDataFunc('hourly', endTime)}
        </span>
      )}
    </div>
  );
}
